// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'
import appheader from './components/public/header.vue' // 公用头部
import apploading from './components/public/loading.vue' // 加载loading
import MetaInfo from 'vue-meta-info'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import Vant from 'vant'
import less from 'less'
import 'vant/lib/index.css'
import '@/styles/index.less'
import { Toast } from 'vant'
import * as echarts from 'echarts'
import 'echarts-liquidfill'
import VueClipboard from 'vue-clipboard2'
import { setCookie, getCookie, delCookie } from './assets/cookie'
import store from './store/store' // Vuex
import appmodal from './components/public/modaldig.vue' // 引入公用自定义弹窗组件


// 播放视频插件
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')


Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

// 引入ues
Vue.use(VueResource)
Vue.use(Vuex)
Vue.use(less)
Vue.use(Vant)
Vue.use(VueWechatTitle)
Vue.use(MetaInfo)
Vue.use(Toast)
Vue.component('app-header', appheader)
Vue.component('app-loading', apploading)
Vue.component('app-modal', appmodal) // 引入公用自定义弹窗组件
Vue.use(VueClipboard)
Vue.use(VideoPlayer) // 播放视频插件

Vue.config.ignoredElements = ['wx-open-subscribe']
Vue.prototype.$cookieStore = {
  setCookie,
  getCookie,
  delCookie
}

// eslint-disable no-new
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
let redirectUrl;
const whiteList = ['/login', '/areacode', '/registration'];
router.beforeEach((to, from, next) => {
  let url = whiteList.indexOf(from.path) === -1 ? from.path : '/';
  window.localStorage.setItem("urlBlckGo", url);
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js